import React, { useState, useEffect } from "react";
const EmptyForm = props => {
    return <div className="details_form info_text">Please choose the asset type to show the details</div>;
}

export default (EmptyForm);